import MobileOsModal from './mobile-os-modal.connect'

export default MobileOsModal
